<template>
  <application-confirm-dialog />
</template>
<script>
import ApplicationConfirmDialog from '@/components/application/dialog/ApplicationConfirmDialog.vue';

export default {
  mounted() {
    this.$store.commit('SPINNER/ON_APP_SPINNER');
    this.$store.commit('DIALOG/TOGGLE_MODAL', 'application_confirm');
  },
  components: {
    ApplicationConfirmDialog,
  },
};
</script>
<style>
/* application.scss 참고 */
</style>
